<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
    X
</button>
<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    <p>{{ message }}</p>
    <span class="detail">
    {{ detail }}
  </span>
</div>
<div mat-dialog-actions></div>
